import { AsyncPipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ContentfulSectionContent } from 'src/app/core/interfaces/Contentful/ContentfulSectionContent';
import { ContentfulProductOverviewContent } from 'src/app/core/interfaces/Contentful/ProductOverview/ContentfulProductOverviewContent';

@Component({
  selector: 'app-contentful-related-products',
  templateUrl: './contentful-related-products.component.html',
  styleUrls: ['./contentful-related-products.component.scss'],
  standalone: true,
  imports: [AsyncPipe],
})
export class AppContentfulRelatedProductsComponent implements OnChanges {
  @Input() contentfulSectionContent: ContentfulSectionContent | undefined;
  contentfulRelatedProductsList$ = new BehaviorSubject<ContentfulProductOverviewContent[]>([]);

  ngOnChanges(changes: SimpleChanges): void {
    const contentfulRelatedProductsCurrentValue = changes.contentfulSectionContent.currentValue;
    const contentfulRelatedProductsContent = contentfulRelatedProductsCurrentValue.contentfulContent?.content;

    if (
      contentfulRelatedProductsContent &&
      contentfulRelatedProductsContent.contents &&
      contentfulRelatedProductsContent.relatedProducts &&
      contentfulRelatedProductsContent.relatedProducts.length > 0 &&
      !this.isEmptyContent(contentfulRelatedProductsContent.relatedProducts)
    ) {
      this.contentfulRelatedProductsList$.next(contentfulRelatedProductsContent.relatedProducts);
    }
  }

  isEmptyContent(content: Array<ContentfulProductOverviewContent>): boolean {
    return content.every((item) => item.title === 'empty-content');
  }
}
